(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sa-marketing-ioquick"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sa-product-setup')) {
    class SaProductSetup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-sa-setup-dialog]');
        this.form = this.querySelector("form[data-type='add-to-cart-form']");
        this.designMode = this.dataset.designMode === 'true' || Boolean(window.Shopify && window.Shopify.designMode);
        this.isSubmitting = false;
        this.onDocClick = this.onDocClick.bind(this);
        this.onChoiceChange = this.onChoiceChange.bind(this);
        this.onEditorSelect = this.onEditorSelect.bind(this);
        this.onQuantityChange = this.onQuantityChange.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);

        this.bindChoices();
        this.bindQuantity();
        this.bindForm();

        document.addEventListener('click', this.onDocClick);

        const section = this.closest('.shopify-section');
        const bindEditor = () => {
          this.designMode = true;
          if (section) {
            section.addEventListener('shopify:section:select', this.onEditorSelect);
            section.addEventListener('shopify:block:select', this.onEditorSelect);
          }
        };

        if (this.designMode) {
          bindEditor();
        } else {
          requestAnimationFrame(() => {
            if (window.Shopify && window.Shopify.designMode) bindEditor();
          });
        }
      }

      getDialog() {
        if (!this.dialog || !this.contains(this.dialog)) {
          this.dialog = this.querySelector('[data-sa-setup-dialog]');
        }
        return this.dialog;
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocClick);
        this.form?.removeEventListener('submit', this.onFormSubmit, true);
        const section = this.closest('.shopify-section');
        section?.removeEventListener('shopify:section:select', this.onEditorSelect);
        section?.removeEventListener('shopify:block:select', this.onEditorSelect);
        this.removeAttribute('open');
        if (this.dialog?.open) this.dialog.close();
        this.dialog?.classList.remove('is-open', 'is-closing');
      }

      get openState() {
        return Boolean(this.getDialog()?.open);
      }

      root() {
        return this.getDialog() || this;
      }

      get controlButtons() {
        if (!this.id) return [];
        return Array.from(document.querySelectorAll('[aria-controls="' + this.id + '"]'));
      }

      syncExpanded() {
        const expanded = this.openState ? 'true' : 'false';
        this.controlButtons.forEach((button) => {
          button.setAttribute('aria-expanded', expanded);
        });
      }

      onEditorSelect(event) {
        const blockId = event.detail?.blockId;
        if (!blockId) return;
        const root = this.root();
        const color = root.querySelector('[data-sa-setup-color][data-block-id="' + blockId + '"]');
        if (color) {
          color.checked = true;
          this.applySelection();
          return;
        }
        const option = root.querySelector('[data-sa-setup-option][data-block-id="' + blockId + '"]');
        if (option) {
          option.checked = true;
          this.applySelection();
          return;
        }
        const combo = root.querySelector('[data-sa-setup-combo][data-block-id="' + blockId + '"]');
        if (!combo) return;
        const parts = String(combo.dataset.key || '').split('-');
        const colorInput = root.querySelector('[data-sa-setup-color][data-sa-setup-index="' + (parts[0] || '') + '"]');
        const optionInput = root.querySelector(
          '[data-sa-setup-option][data-sa-setup-index="' + (parts[1] || '') + '"]',
        );
        if (colorInput) colorInput.checked = true;
        if (optionInput) optionInput.checked = true;
        this.applySelection();
      }

      onDocClick(event) {
        const closeBtn = event.target.closest('[data-sa-setup-close]');
        if (closeBtn && this.root().contains(closeBtn)) {
          event.preventDefault();
          this.close();
          return;
        }

      }

      bindChoices() {
        const root = this.root();
        if (!root) return;

        root.querySelectorAll('[data-sa-setup-color], [data-sa-setup-option]').forEach((input) => {
          input.removeEventListener('change', this.onChoiceChange);
          input.addEventListener('change', this.onChoiceChange);
        });

        const color =
          root.querySelector('[data-sa-setup-color]:checked') || root.querySelector('[data-sa-setup-color]');
        if (color) color.checked = true;

        const option =
          root.querySelector('[data-sa-setup-option]:checked:not(:disabled)') ||
          root.querySelector('[data-sa-setup-option]:not(:disabled)');
        if (option) option.checked = true;

        this.applySelection();
      }

      onChoiceChange() {
        this.applySelection();
      }

      bindQuantity() {
        const root = this.root();
        if (!root) return;
        root.querySelectorAll('[data-sa-quantity-input]').forEach((input) => {
          input.removeEventListener('input', this.onQuantityChange);
          input.removeEventListener('change', this.onQuantityChange);
          input.addEventListener('input', this.onQuantityChange);
          input.addEventListener('change', this.onQuantityChange);
        });
        this.syncQuantity();
      }

      onQuantityChange() {
        this.syncQuantity();
      }

      syncQuantity() {
        const root = this.root();
        if (!root) return;
        const qty = root.querySelector('[data-sa-quantity-input]')?.value || '1';
        root.querySelectorAll('[data-sa-buy-quantity]').forEach((input) => {
          input.value = qty;
        });
        this.syncBuyNowLink();
      }

      parseAvailability() {
        const el = this.querySelector('[data-sa-setup-availability]');
        if (!el) return {};
        try {
          return JSON.parse(el.textContent || '{}') || {};
        } catch (error) {
          return {};
        }
      }

      isVariantAvailable(variantId) {
        const id = String(variantId || '').trim();
        if (!id) return false;
        const map = this.variantAvailability || this.parseAvailability();
        this.variantAvailability = map;
        if (!Object.keys(map).length) return true;
        if (!Object.prototype.hasOwnProperty.call(map, id)) return false;
        return map[id] === true;
      }

      comboVariantId(combos, colorIndex, optionIndex) {
        const combo = combos[`${colorIndex}-${optionIndex}`];
        return String(combo?.dataset.variantId || '').trim();
      }

      setChoiceUnavailable(input, unavailable) {
        const label = input?.closest('.sa-product-setup__choice');
        if (label) label.classList.toggle('is-unavailable', Boolean(unavailable));
      }

      /** Grey border/copy for sold-out choices; keep them clickable. */
      syncChoiceSoldOutStyles() {
        const root = this.root();
        if (!root) return;

        const colors = Array.from(root.querySelectorAll('[data-sa-setup-color]'));
        const options = Array.from(root.querySelectorAll('[data-sa-setup-option]'));
        const combos = this.parseCombos();
        const hasCombos = Object.keys(combos).length > 0;
        const hasOptions = options.length > 0;
        const colorIndex =
          root.querySelector('[data-sa-setup-color]:checked')?.dataset.saSetupIndex || '';
        const optionIndex =
          root.querySelector('[data-sa-setup-option]:checked')?.dataset.saSetupIndex || '';

        if (hasCombos && hasOptions) {
          options.forEach((opt) => {
            const oi = opt.dataset.saSetupIndex || '';
            const vid = colorIndex ? this.comboVariantId(combos, colorIndex, oi) : '';
            this.setChoiceUnavailable(opt, Boolean(vid) && !this.isVariantAvailable(vid));
          });
          colors.forEach((col) => {
            const ci = col.dataset.saSetupIndex || '';
            const vid = optionIndex ? this.comboVariantId(combos, ci, optionIndex) : '';
            this.setChoiceUnavailable(col, Boolean(vid) && !this.isVariantAvailable(vid));
          });
          return;
        }

        colors.forEach((col) => {
          const vid = String(col.dataset.variantId || '').trim();
          this.setChoiceUnavailable(col, Boolean(vid) && !this.isVariantAvailable(vid));
        });
        options.forEach((opt) => this.setChoiceUnavailable(opt, false));
      }

      syncBuyNowLink(variantId) {
        const root = this.root();
        if (!root) return;

        const id = String(
          variantId || this.form?.querySelector('[name="id"]')?.value || '',
        ).trim();
        const qty = Math.max(
          1,
          Number(root.querySelector('[data-sa-quantity-input]')?.value || 1),
        );
        const cartUrl = String(window.theme?.routes?.cart_url || '/cart').replace(/\/$/, '');
        const available = this.isVariantAvailable(id);
        const href = id && available ? `${cartUrl}/${id}:${qty}` : '';
        const buyLabel = root.dataset.buyNowLabel || 'Buy Now';
        const soldOutLabel = root.dataset.soldOutLabel || 'Solld Out';

        root.querySelectorAll('[data-sa-buy-now]').forEach((link) => {
          const labelEl = link.querySelector('[data-sa-buy-now-label]');
          if (href) {
            link.setAttribute('href', href);
            link.removeAttribute('aria-disabled');
            link.removeAttribute('tabindex');
            link.removeAttribute('role');
            link.classList.remove('is-sold-out');
            if (labelEl) labelEl.textContent = buyLabel;
            return;
          }
          link.removeAttribute('href');
          link.setAttribute('aria-disabled', 'true');
          link.setAttribute('tabindex', '-1');
          link.setAttribute('role', 'link');
          link.classList.add('is-sold-out');
          if (labelEl) {
            labelEl.textContent = id ? soldOutLabel : buyLabel;
          }
        });
      }

      bindForm() {
        this.form =
          this.form ||
          this.querySelector("form[data-type='add-to-cart-form']") ||
          this.root()?.querySelector("form[data-type='add-to-cart-form']");
        this.form?.addEventListener('submit', this.onFormSubmit, true);
      }

      onFormSubmit(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.isSubmitting) return;
        const submitter = event.submitter;
        if (submitter?.disabled) return;
        this.submitCart({ activeElement: submitter });
      }

      parseCombos() {
        const map = {};
        this.root()
          ?.querySelectorAll('[data-sa-setup-combo]')
          .forEach((el) => {
            const key = (el.dataset.key || '').trim();
            if (key) map[key] = el;
          });
        return map;
      }

      optionLinkedImageKey(option, colorIndex) {
        if (!option || !colorIndex) return '';
        if (option.getAttribute('data-has-image-' + colorIndex) === 'true') {
          return 'option-' + option.dataset.blockId + '-' + colorIndex;
        }
        return '';
      }

      applySelection() {
        const root = this.root();
        if (!root) return;

        const color = root.querySelector('[data-sa-setup-color]:checked');
        const option = root.querySelector('[data-sa-setup-option]:checked');
        const colorIndex = color?.dataset.saSetupIndex || '';
        const optionIndex = option?.dataset.saSetupIndex || '';
        const combos = this.parseCombos();
        const hasCombos = Object.keys(combos).length > 0;
        const hasOptions = Boolean(root.querySelector('[data-sa-setup-option]'));

        let variantId = (color?.dataset.variantId || '').trim();
        let imageKey = color ? 'color-' + color.dataset.blockId : '';
        const optionImageKey = this.optionLinkedImageKey(option, colorIndex);

        if (hasCombos && hasOptions && colorIndex && optionIndex) {
          const combo = combos[colorIndex + '-' + optionIndex];
          variantId = (combo?.dataset.variantId || '').trim();
          if (combo?.dataset.hasImage === 'true') {
            imageKey = 'combo-' + colorIndex + '-' + optionIndex;
          } else if (optionImageKey) {
            imageKey = optionImageKey;
          }
        } else if (optionImageKey) {
          imageKey = optionImageKey;
        }

        root
          .querySelectorAll('[data-sa-variant-id-input], form[data-type="add-to-cart-form"] [name="id"]')
          .forEach((input) => {
            input.value = variantId || '';
          });

        const hasVariant = Boolean(variantId);
        root
          .querySelectorAll(
            '[data-sa-add-to-cart], form[data-type="add-to-cart-form"] [type="submit"]',
          )
          .forEach((btn) => {
            btn.disabled = !hasVariant;
          });
        this.syncChoiceSoldOutStyles();
        this.syncQuantity();
        this.syncBuyNowLink(variantId);

        root.querySelectorAll('[data-sa-setup-image]').forEach((img) => {
          img.classList.toggle('is-active', img.getAttribute('data-sa-setup-image') === imageKey);
        });

        root.querySelectorAll('[data-sa-setup-option-thumb]').forEach((img) => {
          img.classList.toggle('is-active', img.getAttribute('data-sa-setup-option-thumb') === colorIndex);
        });

        root.querySelectorAll('[data-sa-setup-pdp]').forEach((link) => {
          const base = link.getAttribute('data-sa-setup-pdp');
          if (!base) return;
          link.href = variantId ? `${base}?variant=${variantId}` : base;
        });
      }

      collectItems() {
        const root = this.root();
        const variantId = Number(this.form?.querySelector('[name="id"]')?.value || 0);
        const quantity = Math.max(1, Number(root?.querySelector('[data-sa-quantity-input]')?.value || 1));
        if (!variantId) return [];
        return [{ id: variantId, quantity }];
      }

      actionButtons() {
        const root = this.root();
        if (!root) return [];
        return Array.from(root.querySelectorAll('form[data-type="add-to-cart-form"] [type="submit"]'));
      }

      setActionsBusy(busy, loadingBtn) {
        this.actionButtons().forEach((btn) => {
          if (busy) {
            btn.setAttribute('aria-disabled', 'true');
            if (loadingBtn && btn === loadingBtn) {
              btn.setAttribute('aria-busy', 'true');
            } else {
              btn.removeAttribute('aria-busy');
            }
          } else {
            btn.removeAttribute('aria-busy');
            btn.removeAttribute('aria-disabled');
          }
        });
      }

      async submitCart({ activeElement } = {}) {
        if (this.isSubmitting) return;
        this.syncQuantity();
        const items = this.collectItems();
        if (!items.length) return;

        const loadingBtn =
          activeElement ||
          this.form?.querySelector('[type="submit"]') ||
          this.root()?.querySelector('form[data-type="add-to-cart-form"] [type="submit"]');

        this.isSubmitting = true;
        this.setActionsBusy(true, loadingBtn);

        try {
          const cartAddUrl = window.theme?.routes?.cart_add_url || '/cart/add.js';
          const cartUrl = window.theme?.routes?.cart_url || '/cart';

          const sectionsToBundle = [];
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:bundled-sections', {
              bubbles: true,
              detail: { sections: sectionsToBundle },
            }),
          );
          const sectionIds = [
            ...new Set([
              ...sectionsToBundle,
              ...Array.from(document.querySelectorAll('cart-drawer[data-section-id], cart-items[data-section-id]'))
                .map((el) => el.getAttribute('data-section-id'))
                .filter(Boolean),
            ]),
          ];

          const getSectionsUrl = () => {
            let cartPath = '/cart';
            try {
              cartPath = new URL(cartUrl, window.location.origin).pathname;
            } catch (error) {
              cartPath = cartUrl.split('?')[0];
            }
            if (window.location.pathname === cartPath) {
              return window.theme?.routes?.root_url || '/';
            }
            return window.location.pathname || '/';
          };

          const response = await fetch(cartAddUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
              items,
              sections: sectionIds,
              sections_url: getSectionsUrl(),
            }),
          });
          let parsedState = {};
          try {
            parsedState = await response.json();
          } catch {
            parsedState = {
              status: response.status,
              message:
                response.status === 429
                  ? 'Too many requests. Please refresh the page and try again.'
                  : 'Unable to add product to cart.',
            };
          }

          const isRateLimited =
            Number(response.status) === 429 || Number(parsedState.status) === 429;
          const errorMessage = isRateLimited
            ? parsedState.description ||
              parsedState.message ||
              'Too many requests. Please refresh the page and try again.'
            : parsedState.status && parsedState.status !== 200
              ? parsedState.description || parsedState.message || 'Unable to add product to cart.'
              : response.ok
                ? ''
                : parsedState.message || 'Unable to add product to cart.';

          if (errorMessage) {
            if (window.__SL_toast__?.error) {
              window.__SL_toast__.error({ message: errorMessage });
            } else {
              window.__SL_toast__?.show?.({ message: errorMessage, type: 'error' });
            }
            return;
          }

          window.theme?.pubsub?.publish?.(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: items[0]?.id,
            cart: {
              sections: parsedState.sections,
              items: parsedState.items,
            },
          });
          document.dispatchEvent(
            new CustomEvent('ajaxProduct:added', {
              detail: { product: parsedState },
            }),
          );

          if (document.body.classList.contains('template-cart') || window.theme?.settings?.cartType === 'page') {
            window.location.href = cartUrl;
            return;
          }

          this.close();
          const sectionId = document
            .querySelector('cart-drawer[data-section-id]')
            ?.getAttribute('data-section-id');
          if (sectionId) {
            window.theme?.cart?.syncHeaderCartCount?.(sectionId);
          }
          if (window.theme?.cart?.openDrawer) {
            await window.theme.cart.openDrawer(activeElement, { force: true });
          } else {
            document.querySelector('cart-drawer')?.show?.(activeElement, true, { force: true });
          }
        } catch (error) {
          console.error(error);
        } finally {
          this.isSubmitting = false;
          this.setActionsBusy(false);
        }
      }

      open() {
        const dialog = this.getDialog();
        if (!dialog || typeof dialog.showModal !== 'function' || dialog.open) return;
        try {
          dialog.showModal();
        } catch (error) {
          return;
        }
        this.setAttribute('open', '');
        this.syncExpanded();
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            dialog.classList.add('is-open');
          });
        });
      }

      close() {
        const dialog = this.getDialog();
        if (!dialog || !dialog.open || dialog.classList.contains('is-closing')) return;
        dialog.classList.add('is-closing');
        dialog.classList.remove('is-open');
        this.removeAttribute('open');
        this.syncExpanded();
        const finish = () => {
          dialog.removeEventListener('transitionend', onEnd);
          dialog.classList.remove('is-closing');
          if (dialog.open) dialog.close();
        };
        const onEnd = (event) => {
          if (event.target === dialog) finish();
        };
        dialog.addEventListener('transitionend', onEnd);
        window.setTimeout(finish, 350);
      }
    }

    customElements.define('sa-product-setup', SaProductSetup);
  }

  } catch(e) { console.error(e); }
})();
})();
